import { render, staticRenderFns } from "./bankTest.vue?vue&type=template&id=d72808cc&scoped=true"
import script from "./bankTest.vue?vue&type=script&lang=js"
export * from "./bankTest.vue?vue&type=script&lang=js"
import style0 from "./bankTest.vue?vue&type=style&index=0&id=d72808cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72808cc",
  null
  
)

export default component.exports